//@ts-nocheck
import React from "react";
import { useGLTF } from "@react-three/drei";
import { getFullAssetPath } from "shared/utils/assets";

export function BackgroundChair(props) {
  const { nodes, materials } = useGLTF(
    getFullAssetPath("/objects-v3/chairbaked2-v1.glb"),
  );

  return (
    <group
      {...props}
      dispose={null}
      scale={1.3}
      position={[0.6, -1.48, -2.5]}
      rotation-y={(Math.PI / 2) * 1.11}
    >
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane003_Baked.geometry}
        material={materials["Plane.003_Baked"]}
      />
    </group>
  );
}
